import React from "react";
import { RowBody } from "../../../../components/RowValue/RowBody";
import { useTranslation } from "react-i18next";
import Millimetre from "../../../../components/Math/Units/Metric/Millimetre";

function AbstandKopfplatteÜbergangsrohr({ abstandUebergangsrohr = 0 }) {
  const { t } = useTranslation("translation");

  return (
    <RowBody
      titleValue={<p>{t("aeussre.distanceHeadPlateTransitionTube")}</p>}
      indicesValue={
        <span>
          A<sub>min</sub>
        </span>
      }
      inputValue={<span className="input">{abstandUebergangsrohr}</span>}
      unitValue={<Millimetre />}
    />
  );
}

export default AbstandKopfplatteÜbergangsrohr;
